import {Button, Card, Col, Form, Input, Row} from "antd"
import {FC, PropsWithChildren, useCallback, useState} from "react"
import {formItemConfig} from '@/config/config'
import DrawContainer from '@/components/DrawContainer'
import * as api from "@/api/user"
import {successAlert} from "@/utils/utils"
import {useUserInfoContext} from '@/store/userInfo'

type PropType = FC<PropsWithChildren<{
  onCancel: () => void
}>>

const Edit: PropType = ({ onCancel }) => {
  const { userInfo } = useUserInfoContext()
  const [form] = Form.useForm()
  const [ps, setPs] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSave = useCallback(async () => {
    try {
      await form.validateFields()
      setLoading(true)
      const res = await api.savePassword({
        mm: ps,
        id: userInfo.sys_id
      }).finally(() => {
        setLoading(false)
      })
      if (res.status === 'succeed') {
        successAlert(res.msg,onCancel)
      }
    }catch (e){}

  }, [form, ps, userInfo, onCancel])

  return (
    <DrawContainer
      footer={
        <div>
          <Button onClick={() => onCancel()}>关闭</Button>
          <Button type="primary" className="ml-30" onClick={handleSave} loading={loading}>保存</Button>
        </div>
      }
    >
      <Form form={form}>
        <Card title="基础信息">
          <Row style={{maxWidth: '700px'}}>
            <Col span={24}>
              <Form.Item label="登录名" {...formItemConfig.normal}>
                {userInfo.dlm}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="密码" name="mm" rules={[{ required: true, validator(rule, value, callback) {
                if(!value) {
                  callback('请输入')
                  return
                }
                if(value.length < 9) {
                  callback('密码长度需要大于8位')
                } else {
                  callback()
                }
              } }]} {...formItemConfig.normal}>
                <Input.Password placeholder="密码长度大于8位。需包含字母，区分大小写" onChange={(e) => setPs(e.target.value)} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="确认密码" name="qrmm" rules={[{ required: true, validator(rule, value, callback) {
                if(!value) {
                  callback('请输入')
                  return
                }
                if(ps !== value) {
                  callback('两次输入不一致！')
                } else {
                  callback()
                }
              }, }]} {...formItemConfig.normal}>
                <Input.Password placeholder="密码长度大于8位。需包含字母，区分大小写" />
              </Form.Item>
            </Col>
            
          </Row>
        </Card>
      </Form>
    </DrawContainer>
  )
}

export default Edit
